<ng-container *ngIf="view$ | async as view">
  <section class="progress-card" *ngIf="view.items.length">
    <ng-container [ngSwitch]="view.phase">
      <ng-container *ngSwitchCase="'loading'">
        <app-rotating-title class="qp-title"></app-rotating-title>
        <p class="qp-desc">{{ "comparison.progress.desc" | translate }}</p>
        <div class="qp-progress-bar" role="progressbar" aria-busy="true">
          <span></span>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'slow'">
        <div class="qp-title qp-title--icon">
          <img
            *ngIf="showMascot"
            class="qp-mascot"
            src="assets/image/pawsper.png"
            alt=""
          />
          {{
            (view.ready.length
              ? "comparison.progress.slowSomeReadyTitle"
              : "comparison.progress.slowNoneReadyTitle"
            ) | translate
          }}
        </div>
        <p class="qp-desc">
          <ng-container *ngIf="view.ready.length; else noneReady">
            {{ "comparison.progress.slowSomeReadyDesc" | translate }}
          </ng-container>
          <ng-template #noneReady>
            {{
              (view.waiting.length === 1
                ? "comparison.progress.slowNoneReadyDescOne"
                : "comparison.progress.slowNoneReadyDesc"
              ) | translate : { n: view.waiting.length }
            }}
          </ng-template>
          {{ "comparison.progress.slowRevisit" | translate }}
        </p>
      </ng-container>

      <ng-container *ngSwitchCase="'finished'">
        <div class="qp-title qp-title--ready qp-title--icon">
          <app-progress-status-icon
            class="qp-ready-icon"
            status="ready"
            [pulse]="false"
          ></app-progress-status-icon>
          {{ "comparison.progress.readyTitle" | translate }}
        </div>
        <p class="qp-desc">{{ "comparison.progress.readyDesc" | translate }}</p>
      </ng-container>
    </ng-container>

    <div class="progress-card__chips">
      <app-progress-chip
        *ngFor="let item of view.items; trackBy: trackById"
        [item]="item"
        [attr.data-chip-id]="item.id"
        (chipClick)="scrollTo($event)"
      ></app-progress-chip>
    </div>
  </section>
</ng-container>
